import { render, staticRenderFns } from "./translate_slot_dialog.vue?vue&type=template&id=da8770d0"
import script from "./translate_slot_dialog.vue?vue&type=script&lang=js"
export * from "./translate_slot_dialog.vue?vue&type=script&lang=js"
import style0 from "./translate_slot_dialog.vue?vue&type=style&index=0&id=da8770d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports